import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { Address } from "../../../../../../Wrap/Models/Domains/Address/Address";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { AriaTooltip } from "../../../../../Shared/Tooltip/AriaTooltip";

export const SectionHeader = (
    title: string | JSX.Element,
    tooltipContent?: string | JSX.Element,
    tooltipCss?: string
): JSX.Element => {
    return (
        <h3>
            <b>{title}</b>{" "}
            {tooltipContent && (
                <AriaTooltip cssWrapper={"is-info-icon " + (tooltipCss || "")}>{tooltipContent}</AriaTooltip>
            )}
        </h3>
    );
};

interface IThreeColLayoutProps extends React.Props<ThreeColLayout> {
    colOne?: JSX.Element | string | React.Component;
    colTwo?: JSX.Element | string | React.Component;
    colThree?: JSX.Element | string | React.Component;
}

export class ThreeColLayout extends BaseComponent<IThreeColLayoutProps, {}> {
    render() {
        return (
            <div className="row">
                <div className="col-7">{this.props.colOne}</div>
                <div className="col-3">{this.props.colTwo}</div>
                <div className="col-2">{this.props.colThree}</div>
            </div>
        );
    }
}

export const renderAddComponent = (title: string, onClick: VoidFunction): JSX.Element => {
    return (
        <button className="add-button" onClick={() => onClick()}>
            <span className="icon" aria-hidden="true" />
            <span className="text">{title}</span>
        </button>
    );
};

export const renderAddress = (address: Address): JSX.Element => {
    if (!address) {return null;}
    return (
        <ul className="list">
            <li>{address.Line1}</li>
            <li>{address.Line2}</li>
            <li>{address.Line3}</li>
            <li>{address.Line4}</li>
            <li>{CountryCodeMap.getString(address.CountryCode)}</li>
            <li>{address.Postcode}</li>
        </ul>
    );
};

export const emptyAddress: Address = {
    Line1: null,
    Line2: null,
    Line3: null,
    Line4: null,
    Postcode: null,
    CountryCode: null,
};

export const TrueFalseRadio = (
    label: string,
    key: string,
    data,
    onChange: (key, v) => void,
    required?,
    options?,
    tooltip?: string
) => {
    return (
        <RadiosEditor
            cssWrapper="rg-inline mb-16"
            label={label}
            tooltip={tooltip}
            selected={data[key]}
            options={[true, false]}
            getText={(v) => (v ? "Yes" : "No")}
            onChange={(v) => onChange(key, v)}
            required={required ? "Please select " + label : null}
            {...options}
        />
    );
};
